import { render } from "./generateOrder.vue?vue&type=template&id=3685e87a"
import script from "./generateOrder.vue?vue&type=script&lang=js"
export * from "./generateOrder.vue?vue&type=script&lang=js"
script.render = render

export default script